import { OPTIMIZELY_ACTIONS } from 'actions/actions-const';

const initialState = {
  optimizely: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case OPTIMIZELY_ACTIONS.SET_EXPERIMENTS:
      return {
        ...state,
        ...action.experiments,
      };

    default:
      return state;
  }
}

/**
 * Given the current state, it returns the state of the optimizely experiments
 * @param {object} state
 * @returns {object}
 */
export const getOptimizelyExperiments = (state) => state.optimizely;
